/**
 * pagedAll — THE shared guard against PostgREST's silent 1000-row cap
 * ([[reference_shared_guards]]): every response is truncated at 1000 rows
 * regardless of .limit(), so any list that can exceed that MUST page.
 * `build` must return a FRESH query each call (builders are mutable) with a
 * stable ORDER BY. Promoted to lib from agreements/api (LISTS-01).
 */
export async function pagedAll<T>(
  build: () => PromiseLike<{ data: unknown; error: { message: string } | null }> & {
    range: (from: number, to: number) => PromiseLike<{ data: unknown; error: { message: string } | null }>;
  },
  hardCap = 50000,
): Promise<T[]> {
  const out: T[] = [];
  const page = 1000;
  for (let from = 0; out.length < hardCap; from += page) {
    const { data, error } = await build().range(from, from + page - 1);
    if (error) throw new Error(error.message);
    const batch = (data ?? []) as T[];
    out.push(...batch);
    if (batch.length < page) break;
  }
  return out;
}
